(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["avis-clients"] && !window.DesignMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
  let slides = document.getElementsByClassName("avis-slide");
  let dots = document.getElementsByClassName("avis-dot");
  let currentIndex = 0;
  let autoSlideInterval;
  const slideInterval = 5000; // 5 secondes

  function showSlide(index) {
    if (index >= slides.length) index = 0;
    if (index < 0) index = slides.length - 1;

    for (let i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
      dots[i].classList.remove("active");
    }

    slides[index].style.display = "block";
    dots[index].classList.add("active");
    currentIndex = index;
  }

  function startAutoSlide() {
    autoSlideInterval = setInterval(function() {
      showSlide(currentIndex + 1);
    }, slideInterval);
  }

  // Initialisation
  showSlide(currentIndex); // Afficher la première slide
  startAutoSlide(); // Démarrer le défilement automatique

  document.querySelector('.avis-prev').addEventListener('click', function() {
    showSlide(currentIndex - 1);
  });

  document.querySelector('.avis-next').addEventListener('click', function() {
    showSlide(currentIndex + 1);
  });
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  document.addEventListener('DOMContentLoaded', function() {
    // Vérifier si l'écran est en mode mobile
    if(window.innerWidth <= 749) {
        // Obtenir tous les blocs de type 'link_list'
        var linkLists = document.querySelectorAll('.footer-block--menu');

        linkLists.forEach(function(list) {
            // Obtenir le titre pour chaque liste
            var header = list.querySelector('.footer-block__heading');
            
            // Ajouter un écouteur d'événement de clic sur le titre
            header.addEventListener('click', function() {
                // Ajouter/retirer la classe 'collapsible' pour montrer/cacher le contenu
                list.classList.toggle('collapsible');
            });
        });
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-youtube-slider"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  let slides = document.getElementsByClassName("slide");
  let dots = document.getElementsByClassName("dot");
  let currentIndex = 0;

  function showSlide(index) {
    if (index >= slides.length) { currentIndex = 0; }
    if (index < 0) { currentIndex = slides.length - 1; }
    for (let i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";  
      dots[i].className = dots[i].className.replace(" active", "");
    }
    slides[currentIndex].style.display = "block";  
    dots[currentIndex].className += " active";
  }

  showSlide(currentIndex);

  document.querySelector('.prev').addEventListener('click', function() {
    showSlide(--currentIndex);
  });

  document.querySelector('.next').addEventListener('click', function() {
    showSlide(++currentIndex);
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-image-text"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var slides = document.querySelectorAll('.slide');
  var dots = document.querySelectorAll('.dot');
  var currentSlide = 0;


  function showSlide(n) {
    slides.forEach(function(slide, index){
      slide.style.display = 'none';
      dots[index].className = dots[index].className.replace(' active', '');
    });
    slides[n].style.display = 'block';
    dots[n].className += ' active';
  }

  function currentSlide(n) {
    clearInterval(slideInterval);
    showSlide(n);
    currentSlide = n;
    slideInterval = setInterval(nextSlide,3000);
  }

  function nextSlide() {
    currentSlide = (currentSlide+1)%slides.length;
    showSlide(currentSlide);
  }

  var next = document.querySelector('.right-arrow');
  var previous = document.querySelector('.left-arrow');

  next.onclick = function() {
    nextSlide();
  };
  previous.onclick = function() {
    currentSlide = (currentSlide-1+slides.length)%slides.length;
    showSlide(currentSlide);
  };

  window.currentSlide = currentSlide;
});

  } catch(e) { console.error(e); }
})();

})();
